import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { CreateClientComponent } from './create-client.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [CreateClientComponent],
  providers: [],
  exports: [CreateClientComponent]
})

export class CreateClientModule {

}
